export enum AccessibilityCodes {
  HACC = 'hacc',
  NHACC = 'nhacc',
  CCT = 'cct',
}

export const visionDiscountServiceCode = 'VD';
